import { styled } from '@mui/material/styles';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InternalLoginForm from '../../components/auth/InternalLoginForm';
import authService from '../../services/authService';

const PREFIX = 'Login';

const classes = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
  left: `${PREFIX}-left`,
  right: `${PREFIX}-right`,
  center: `${PREFIX}-center`,
  logo1: `${PREFIX}-logo1`,
  logo2: `${PREFIX}-logo2`,
  logo3: `${PREFIX}-logo3`,
  logo4: `${PREFIX}-logo4`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'row',
    flex: '0 1 100%',
    backgroundColor: theme.palette.info,
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: 'url(/background_small.png)',
    },
    [theme.breakpoints.up('sm')]: {
      backgroundImage: 'url(/background.png)',
    },
  },

  [`& .${classes.left}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 65,
    alignItems: 'end',
  },

  [`& .${classes.right}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: 65,
    alignItems: 'left',
  },

  [`& .${classes.center}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
    alignItems: 'center',
  },

  [`& .${classes.logo1}`]: {
    width: 400,
    marginBottom: 19,
  },

  [`& .${classes.logo2}`]: {
    width: 230,
    marginTop: 18,
    marginRight: 85,
  },

  [`& .${classes.logo3}`]: {
    width: 163,
    marginBottom: 19,
  },

  [`& .${classes.logo4}`]: {
    width: 137,
    marginTop: 18,
  },
}));

export default function InternalLogin() {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up('md'));
  const navigate = useNavigate();

  const login = (_data: any, evt: any) => {
    evt.preventDefault();
    const customProvder = authService.getFederatedCustomProvider(null);
    authService.loginFederated(customProvder || '').then(() => {
      navigate('/');
    });
    return false;
  };

  return (
    <Root className={classes.container}>
      {isLarge && (
        <Box className={classes.left}>
          <img alt="RideCafe" src="/logo.png" className={classes.logo1} />
          <img
            alt="AmericanLogistics"
            src="/logo2.png"
            className={classes.logo2}
          />
        </Box>
      )}
      {isLarge && (
        <Box className={classes.right}>
          <InternalLoginForm submit={login} />
        </Box>
      )}
      {!isLarge && (
        <Box className={classes.center}>
          <img alt="RideCafe" src="/logo.png" className={classes.logo3} />
          <InternalLoginForm submit={login} />
          <img
            alt="AmericanLogistics"
            src="/logo2.png"
            className={classes.logo4}
          />
        </Box>
      )}
    </Root>
  );
}
